import queryString from 'query-string';

import LocalStorageService from '../services/local-storage-service';
import { createBaseApi } from '../utils/baseApi';

const apiUrl = `${window.location.origin}/osiris/book/api-react`;

const key = LocalStorageService.retrieve('pins-key') || queryString.parse(window.location.search).key;

const { getJson, postJson } = createBaseApi(apiUrl, { params: { key } });

export const getAppSessionDetails = () => getJson('/session-details/');
export const getCompanyLogo = () => getJson('/logo/');
export const getDepartment = () => getJson('/department/');
export const getPolicies = policyIds => postJson('/policies/', policyIds);
export const getTemplates = () => getJson('/templates/');
export const getUser = () => getJson('/user/');
export const saveTemplate = template => postJson('/template/', template);
export const deleteTemplate = templateId => postJson('/delete_template/', templateId);
export const generatePresignedPutUrl = s3Key => postJson('/generate-presigned-put-url/', s3Key);
